<div class="modal-video-youtube">
  <pot-icon-svg-close [fillColor]="'white'" (click)="close()"></pot-icon-svg-close>

  <div class="video-container">
    <iframe class="video" [src]="videoUrl | safeUrl" allowfullscreen></iframe>
  </div>
</div>
